import { render, staticRenderFns } from "./Left_sideMenu.vue?vue&type=template&id=792cabbf&scoped=true"
import script from "./Left_sideMenu.vue?vue&type=script&lang=js"
export * from "./Left_sideMenu.vue?vue&type=script&lang=js"
import style0 from "./Left_sideMenu.vue?vue&type=style&index=0&id=792cabbf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792cabbf",
  null
  
)

export default component.exports